import React, { memo } from 'react'

import customConfig from 'customConfig'
import RecordsNotFound from '../shared/recordsNotFound/RecordsNotFound'
import NftCard from './NftCard'
import SkeletonLoading from './SkeletonLoading'
import CardGridLayout from '../shared/grid/CardGridLayout'

const NftList = ({ nfts, onSelectNft, t, loadingNftBalance }) => {
  const emptyNfts = nfts && nfts.length === 0
  if (loadingNftBalance) {
    return (
      <CardGridLayout>
        <SkeletonLoading />
      </CardGridLayout>
    )
  }
  return (
    <>
      {emptyNfts ? (
        <RecordsNotFound
          icon={customConfig.nftIcon}
          description={t('brand:nft.no-nfts-found')}
        />
      ) : (
        <CardGridLayout>
          {nfts?.map((nft, index) => {
            return (
              <NftCard
                t={t}
                key={index}
                nft={nft}
                onClick={() => onSelectNft(nft)}
              />
            )
          })}
        </CardGridLayout>
      )}
    </>
  )
}

export default memo(NftList)
